import request from './request'

export const getOrderList = (params) => {
  return request({
    url: '/admin/orders',
    method: 'get',
    params
  })
}

export const getOrderDetail = (id) => {
  return request({
    url: `/admin/orders/${id}`,
    method: 'get'
  })
}

export const getOrderItems = (orderId) => {
  return request({
    url: `/admin/orders/${orderId}/items`,
    method: 'get'
  })
}

export const updateOrderStatus = (id, status) => {
  return request({
    url: `/admin/orders/${id}/status`,
    method: 'put',
    data: { status }
  })
}

export const deleteOrder = (id) => {
  return request({
    url: `/admin/orders/${id}`,
    method: 'delete'
  })
}
